import { ErrorBoundary, Notice, SearchInput, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { HeaderSection } from './components/HeaderSection';
import { SentOrderList } from './components/SentOrderList';
import { SubHeader } from './components/SubHeader';
import { searchPlaceholder } from './constants';
import { RateManagementTypes } from './types';

export const ContainerDesktop: React.FC<RateManagementTypes.Props> = ({
  isMobile,
  onSetSearchTerm,
  onClearSearchTerm,
  onRefresh,
  onLoadMore,
  sentOrders,
  sentOrdersLoading,
  sentOrdersError,
  searchTerm,
}) => {
  return (
    <VStack
      paddingX={Utils.Responsive.TabletDesktop({
        tablet: Spacing['inline.xxxs'],
        desktop: Spacing['inline.xs'],
      })}
      paddingY={Spacing['inline.xxxs']}
      maxWidth={1200}
      alignSelf={'center'}
      width="100%"
      flex={1}>
      <VStack flex={1} justifyContent="flex-start">
        <HeaderSection isMobile={isMobile} />
        <SubHeader onRefresh={onRefresh} isMobile={isMobile} loading={sentOrdersLoading} />
        <VStack
          flex={1}
          bg={{ base: 'transparent', sm: Color['neutral.white'] }}
          px={{ sm: Spacing['inline.xxs'] }}
          py={Spacing['stack.xxs']}>
          {sentOrdersError ? (
            <ErrorBoundary onRefresh={onRefresh} />
          ) : (
            <>
              <SearchInput
                isLoading={sentOrdersLoading}
                onClear={onClearSearchTerm}
                onSearch={onSetSearchTerm}
                placeholder={searchPlaceholder}
              />
              <Notice
                textObjects={[
                  {
                    text: 'Solicitações de débito feitas até às 12h serão executadas na mesma data do envio. Caso contrário, o débito ocorrerá no próximo dia útil.',
                    variant: 'regular',
                  },
                ]}
                testId="notice"
                type="alert"
                my="20px"
              />
              <SentOrderList
                hasSearch={!!searchTerm}
                sentOrders={sentOrders}
                sentOrdersLoading={sentOrdersLoading}
                onLoadMore={onLoadMore}
              />
            </>
          )}
        </VStack>
      </VStack>
    </VStack>
  );
};
